var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-info" }, [
    _c(
      "div",
      {
        staticClass: "profile-info__details has-text-white",
        class: _vm.profileBoxStyle
      },
      [
        _c(
          "div",
          { staticClass: "status-box" },
          [
            _vm.studentProfile.activeAlerts > 0
              ? _c(
                  "pill",
                  { attrs: { status: "tertiary" } },
                  [_c("icon-warning-white"), _vm._v(" Con alertas\n      ")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canEditEnrollmentState
              ? _c(
                  "a",
                  {
                    staticClass: "edit-btn",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.navigateTo("app.profile.change_situation")
                      }
                    }
                  },
                  [
                    _c("edit-icon", {
                      staticStyle: { width: "1.5em", height: "1.5em" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "basic-info columns",
            staticStyle: { position: "relative" }
          },
          [
            _c("div", { staticClass: "profile-pic column is-narrow" }, [
              _c("div", { staticClass: "profile-pic-box" }, [
                _vm.studentProfile.student.avatar && !_vm.avatarFailed
                  ? _c("div", [
                      _c("img", {
                        staticClass: "profile-avatar-img",
                        attrs: { src: _vm.studentProfile.student.avatar },
                        on: { error: _vm.disableAvatar }
                      })
                    ])
                  : _c("div", [_c("male-avatar")], 1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-info-content column" }, [
              _c("p", { staticClass: "student-id" }, [
                _vm._v(_vm._s(_vm.studentProfile.student.code))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "student-firstname" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.navigateTo("app.profile")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.studentProfile.student.name))]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "student-program" }, [
                _vm._v(_vm._s(_vm.formattedProgramLine))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "risk-level-info" }, [
                _c("span", { staticClass: "risk-level-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("percentage")(
                        _vm.studentProfile.student.desertionProbability
                      )
                    )
                  )
                ]),
                _vm._v(
                  "\n\n          " + _vm._s(_vm.riskDescription) + "\n        "
                )
              ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "contact has-background-white" }, [
      _c(
        "div",
        { staticClass: "contact-basic" },
        [
          _c("h4", { staticClass: "title" }, [_vm._v("CONTACTO")]),
          _vm._v(" "),
          _vm._l(_vm.studentProfile.student.phoneNumbers, function(
            item,
            index
          ) {
            return _c("div", { key: index, staticClass: "contact-item" }, [
              _c(
                "span",
                {
                  staticClass: "contact-item-icon",
                  class: { invisible: index != 0 }
                },
                [_c("telephone-icon")],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "contact-item-value",
                  attrs: { href: _vm.callTo(item) }
                },
                [_vm._v(_vm._s(item))]
              )
            ])
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "7px" } }),
          _vm._v(" "),
          _vm._l(_vm.studentProfile.student.emailAddresses, function(
            item,
            index
          ) {
            return _c("div", { key: index + 99, staticClass: "contact-item" }, [
              _c(
                "span",
                {
                  staticClass: "contact-item-icon",
                  class: { invisible: index != 0 }
                },
                [_c("mail-icon")],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "contact-item-value",
                  attrs: { href: _vm.mailTo(item) }
                },
                [_vm._v(_vm._s(item))]
              )
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "student-enrollment" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("MATRÍCULA")]),
        _vm._v(" "),
        _c("p", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.enrolledSinceText))
        ])
      ]),
      _vm._v(" "),
      this.studentProfile.student.responsible
        ? _c("div", { staticClass: "student-responsible" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("RESPONSABLE")]),
            _vm._v(" "),
            _c("p", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.responsibleName))
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "more-info has-text-grey has-background-white fs-14" },
      [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.navigateTo("app.profile.info")
              }
            }
          },
          [_vm._v("+ Más información")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }